module.exports = __webpack_public_path__ + "static/img/zleepers-2.aba8432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/zleepers-2.jpg
// module id = GyNz
// module chunks = 1